import { VESSELPTMCHECKED } from "../../actions/portal/";

export default function(state = false, action) {
  switch (action.type) {
    case VESSELPTMCHECKED:
      return action.payload;
    default:
  }

  return state;
}
